import { render, staticRenderFns } from "./about.vue?vue&type=template&id=858b081a&scoped=true&"
var script = {}
import style0 from "./about.vue?vue&type=style&index=0&id=858b081a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858b081a",
  null
  
)

export default component.exports